import { NAMESPACE } from './index';
import { ClientFlashMessagesState } from './reducers';
import { FlashMessage } from '@pegasus/ui-flashmessages/types/flashmessage';

export const getClientFlashMessages = (state: ClientFlashMessagesState): FlashMessage[] =>
    state[NAMESPACE].view.messages || [];
